/** Sidebar filters for the integrations marketplace modal. */
export const INTEGRATION_FILTER_CATEGORIES = [
  { id: 'all', label: 'All', mode: 'all' },
  { id: 'developer', label: 'Developer Tools & DevOps', sectionId: 'developer' },
  { id: 'collaboration', label: 'Collaboration & Communication', sectionId: 'collaboration' },
  { id: 'ai-ml', label: 'AI & Machine Learning', sectionId: 'ai-ml' },
  { id: 'doc', label: 'Document & File Management', sectionId: 'doc' },
  { id: 'productivity', label: 'Productivity & Project Management', sectionId: 'productivity' },
  { id: 'crm', label: 'CRM', sectionId: 'crm' },
  { id: 'analytics', label: 'Analytics & Data', sectionId: 'analytics' },
  { id: 'entertainment', label: 'Entertainment & Media', sectionId: 'entertainment' },
  { id: 'education', label: 'Education & LMS', sectionId: 'education' },
  { id: 'design', label: 'Design & Creative Tools', sectionId: 'design' },
  { id: 'marketing', label: 'Marketing & Social Media', sectionId: 'marketing' },
  { id: 'scheduling', label: 'Scheduling & Booking', sectionId: 'scheduling' },
  { id: 'ecommerce', label: 'E-commerce', sectionId: 'ecommerce' },
  { id: 'finance', label: 'Finance & Accounting', sectionId: 'finance' },
  { id: 'sales', label: 'Sales & Customer Support', sectionId: 'sales' },
  { id: 'hr', label: 'HR & Recruiting', sectionId: 'hr' },
  { id: 'workflow', label: 'Workflow Automation', sectionId: 'workflow' },
  { id: 'other', label: 'Other', sectionId: 'other' },
]
